import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { Modal } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styled from 'styled-components/native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export function UploadProgressOverlay({ visible, stage, currentIndex, totalImages, progress, imageSizeMb, label, onCancel, }) {
    const photoLabel = label !== null && label !== void 0 ? label : '사진';
    const isRegistering = stage === 'registering';
    const titleText = isRegistering
        ? '정보 등록 중...'
        : `${photoLabel} 업로드 중 (${currentIndex + 1}/${totalImages})`;
    const progressPercent = Math.round(progress * 100);
    return (_jsx(Modal, { transparent: true, visible: visible, animationType: "fade", statusBarTranslucent: true, onRequestClose: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel(), children: _jsx(Overlay, { children: _jsx(SafeContent, { edges: ['top', 'bottom'], children: _jsxs(Card, { children: [_jsx(TitleText, { children: titleText }), _jsx(SizeText, { children: isRegistering
                                ? ' '
                                : stage === 'compressing'
                                    ? '압축 중'
                                    : imageSizeMb > 0
                                        ? `${imageSizeMb.toFixed(2)} MB`
                                        : '업로드 중' }), _jsx(ProgressBarContainer, { children: _jsx(ProgressBarFill, { style: { width: `${progressPercent}%` } }) }), _jsx(PercentText, { children: isRegistering ? ' ' : `${progressPercent}%` }), onCancel && !isRegistering && (_jsx(CancelButton, { elementName: "upload_progress_cancel", accessibilityRole: "button", onPress: onCancel, children: _jsx(CancelText, { children: "\uCDE8\uC18C" }) }))] }) }) }) }));
}
const Overlay = styled.View `
  flex: 1;
  background-color: ${color.blacka50};
`;
const SafeContent = styled(SafeAreaView) `
  flex: 1;
  align-items: center;
  justify-content: center;
`;
const Card = styled.View `
  background-color: ${color.white};
  border-radius: 16px;
  padding: 24px;
  align-items: center;
  min-width: 260px;
`;
const TitleText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 16px;
  line-height: 24px;
  color: ${color.gray80};
  margin-bottom: 8px;
`;
const SizeText = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 13px;
  line-height: 18px;
  color: ${color.gray50};
  margin-bottom: 12px;
`;
const ProgressBarContainer = styled.View `
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: #e5e5e5;
  overflow: hidden;
`;
const ProgressBarFill = styled.View `
  height: 6px;
  border-radius: 3px;
  background-color: ${color.lightOrange};
`;
const PercentText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 13px;
  line-height: 18px;
  color: ${color.gray50};
  margin-top: 8px;
`;
const CancelButton = styled(SccTouchableOpacity) `
  margin-top: 12px;
  padding: 8px 24px;
`;
const CancelText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 14px;
  line-height: 20px;
  color: ${color.gray70};
  text-decoration-line: underline;
`;
